var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"font-small-icon",attrs:{"viewBox":"0 0 10 10","width":_vm.size,"height":_vm.size}},[_c('path',{attrs:{"d":"M10 0H0v2.4h3.7V10h2.6V2.4H10z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }